<div class="container-fluid" style="padding: 20px 0 0 0" *ngIf="shoppingCart.length === 0">
    Ihr Warenkorb ist noch leer
</div>
<div class="container-fluid" style="padding: 20px 0 0 0; margin-bottom: 116px" *ngIf="shoppingCart.length > 0">
    <table class="table table-striped">
        <thead>
        <tr>
            <th>Auftrag</th>
            <th>Produkt</th>
            <th>Gebiet/e</th>
            <th>Zeitraum</th>
            <th>Quelle</th>
            <th>Entfernen</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let item of shoppingCart">
            <td>{{item.orderName}}</td>
            <td>{{item.productType}}</td>
            <td style="word-wrap: anywhere">{{item.selectedRegions}}</td>
            <td
                    *ngIf="item.startDate && item.endDate; else elseBlock">{{item.startDate.month + '/' + item.startDate.year + ' - ' + item.endDate.month + '/' + item.endDate.year}}</td>
            <ng-template #elseBlock>
                <td>-</td>
            </ng-template>
            <td>{{item.dopUploadID}}</td>
            <td>
                <button (click)="removeCartEntry(item.orderId)" type="button" class="btn btn-outline-secondary btn-sm">
                    Entfernen
                </button>
            </td>
        </tr>
        </tbody>
    </table>
    <div class="d-flex flex-row align-items-center justify-content-end" style="width: 100%">
        <button type="button" class="btn btn-outline-danger" (click)="openModal(content)">Warenkorb löschen</button>&nbsp;&nbsp;
        <button type="button" class="btn btn-outline-primary" (click)="sendCart()">Warenkorb abschicken</button>
    </div>
    <div>
        <ngb-alert [dismissible]="false" type="{{validRequest.type}}">
            {{validRequest.message}}
        </ngb-alert>
    </div>
    <div class="card" style="margin-top: 20px; text-align: justify">
        <h6 class="card-header">Weiterführende Informationen</h6>
        <div class="card-body">
            <p>Nach Fertigstellung aller im Auftrag enthaltenen Berechnungen, wird eine E-Mail versendet. In dieser ist ein
                Downloadlink zu den Ergebnissen im zip-Format und ein Fehlerprotokoll, falls bei der Verarbeitung ein Problem
                entstanden sein sollte, vorhanden. Dieses Protokoll kann entstehen, wenn beispielsweise eine nicht ausreichende
                Anzahl von Satellitenbildern für den gewählten Zeitraum zur Verfügung steht.</p>
        </div>
    </div>
    <ng-template #content let-modal>
        <div class="modal-header">
            <h4 class="modal-title">Warenkob löschen</h4>
        </div>
        <div class="modal-body">
            <p>Möchten Sie wirklich alle Einträge aus dem Warenkob entfernen?</p>
        </div>
        <div class="modal-footer">
            <button class="btn btn-outline-primary" (click)="modal.close('Close click')">
                Abbrechen
            </button>
            <button class="btn btn-outline-danger" (click)="removeCart()">
                Löschen
            </button>
        </div>
    </ng-template>
</div>
<app-loader class="appLoader" *ngIf="showLoader"></app-loader>
